
<template>
  <div class="container-fluid loginPages p-0">
    <div class="container py-3 py-md-4 px-0">
      <div class="row m-0">
        <img src="static/images/logo.png" class="img-fluid" />
      </div>
    </div>
    <div
      v-if="twofaActivated == false"
      class="container py-3 py-md-4 px-3 loginInfo"
    >
      <div
        class="list-panel-header columns is-desktop has-background-info-dark px-3 has-text-white mb-0 mx-0"
      >
        <div
          class="column has-text-centered has-text-left-desktop d-flex justify-content-between align-items-center"
        >
          <span class="is-size-4"
            >{{ $ml.get("google_two_step_verification_setup") }}
          </span>
          <a
            class="btn btn-link text-dark"
            href="loginTwoFactorHelp"
            target="_blank"
          >
            <i class="bi bi-exclamation-circle-fill mb-1"></i> Yardım</a
          >
        </div>
      </div>
      <div class="row columns is gapless has-background-white mx-0">
        <div class="col-md-4 column ms-3 has-border-right-light mb-10">
          <span class="is-size-4 numberSpan px-2 me-1">1</span>
          <span class="is-size-4 fw600">{{ $ml.get("download_the_app") }}</span>
          <p class="pt-1 lh13">{{ $ml.get("download_the_app_text") }}</p>
          <div>
            <a
              href="https://apps.apple.com/tr/app/google-authenticator/id388497605?l"
              target="_blank"
            >
              <img
                src="static/images/mincrm-appstore-logo.png"
                alt=""
                class="img-fluid"
              />
            </a>
          </div>
          <div>
            <a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=tr&gl"
              target="_blank"
            >
              <img
                src="static/images/mincrm-googleplaystore-logo.png"
                alt=""
                class="img-fluid"
              />
            </a>
          </div>
        </div>
        <div class="col-md-4 column ms-3 has-border-right-light mb-10">
          <span class="is-size-4 numberSpan px-2 me-1">2</span>
          <span class="is-size-4 fw600">{{ $ml.get("scan_qr_code") }}</span>
          <p class="pt-1 lh13">{{ $ml.get("scan_qr_code_text") }}</p>
          <div class="columns mx-0">
            <div class="column p-0 has-text-centered">
              <img
                :src="`${initialize2faData.qrImageDownloadLink}`"
                alt="qr kod"
              />
            </div>
          </div>
          <label class="has-text-weight-bold" for="">{{
            $ml.get("recovery_code")
          }}</label>
          <div class="inputStyle">
            <p id="recoveryCode" class="mb-0 py-2">
              {{ initialize2faData.twofaSecret }}
            </p>
            <span
              class="mdi mdi-content-copy copyIcon pr13"
              @click="copyToCode()"
            ></span>
          </div>
          <p
            class="has-background-primary-light pt-1 pb-4 fs13 numberSpann px-2 lh13"
          >
            {{ $ml.get("recovery_code_text") }}
          </p>
        </div>
        <div class="col-md-4 column ms-3 mb-10">
          <span class="is-size-4 numberSpan px-2 me-1">3</span>
          <span class="is-size-4 fw600">{{
            $ml.get("enter_verification_code")
          }}</span>
          <p class="pt-1 lh13">{{ $ml.get("verification_code_text") }}</p>
          <div class="column warningDiv py-2">
            <p class="mb-0">
              <i class="mdi mdi-alert-circle me-1"></i> Lütfen Dikkat
            </p>
          </div>
          <div class="column pinkCol mb-4">
            <p class="fs13 pinkColText pt-1">
              {{ $ml.get("download_pdf_text") }}
            </p>
            <button
              @click="pdfDownload()"
              class="btnBorder btn btn-link ps-0 pinkColBtn pt-3"
            >
              {{ $ml.get("download_pdf") }}
            </button>
          </div>

          <input
            name="googleAuthCode"
            v-model="googleAuthenticatorCode"
            class="form-control form-control-lg form-control-solid mb-4"
            placeholder="Google Authenticator Kodu"
          />
          <button class="btn btn-primary" @click="activate_2faF()">
            {{ $ml.get("activate_verification_code") }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-else-if="twofaActivated == true"
      class="container loginInfo contDiv has-text-centered is-max-desktop p-5 has-background-white"
    >
      <span class="is-size-4 has-text-weight-bold">{{
        $ml.get("two_step_verification_code")
      }}</span>
      <p class="pt-4 text-center">
        {{ $ml.get("two_step_verification_text") }}
      </p>
      <div class="pt-3 menuMobil">
        <input
          v-model="input1"
          maxlength="1"
          id="input1"
          class="inputNumberStyle mr-1"
          @keyup="inputFocus($event)"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
        <input
          @keyup="inputFocus($event)"
          v-model="input2"
          maxlength="1"
          class="inputNumberStyle mr-1"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
        <input
          @keyup="inputFocus($event)"
          v-model="input3"
          maxlength="1"
          class="inputNumberStyle mr-1"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
        <input
          @keyup="inputFocus($event)"
          v-model="input4"
          maxlength="1"
          class="inputNumberStyle mr-1"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
        <input
          @keyup="inputFocus($event)"
          v-model="input5"
          maxlength="1"
          class="inputNumberStyle mr-1"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
        <input
          @keyup="inputFocus($event)"
          v-model="input6"
          maxlength="1"
          class="inputNumberStyle mr-1"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="pt-4 text-center">
        <a
          class="colorGray cursorPointer"
          href="loginTwoFactorHelp"
          target="_blank"
          >Kod Çalışmıyor mu?</a
        >
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Footer from "./footer.vue";
import defineAbilityFor from "../services/rules";

import Swal from "sweetalert2";
export default {
  name: "loginTwoFactor",
  data() {
    return {
      googleAuthenticatorCode: "",
      twofaActivated: "",
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      input6: "",
      auth_code: "",
      initialize2faData: {
        qrPdfDownloadLink: "",
        qrImageDownloadLink: "",
        twofaSecret: "",
        twofaqrPath: "",
      },
      loginForm: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState(["baseUrl", "windowWidth", "maxMobilSize", "maxTabletSize"]),
    ...mapGetters(["company_settings"]),
  },
  components: {
    Footer,
  },
  methods: {
    ...mapActions(["updateLoading", "getCompanySettings", "setUserName"]),
    twofaActivatedControl() {
      this.twofaActivated = JSON.parse(localStorage.getItem("twofaActivated"));
    
      if (this.twofaActivated === false) {
        this.initialize_2faF();
      }
    },

    activate_2faF() {
      if (this.googleAuthenticatorCode.length > 0) {
       
        axios({
          method: "POST",
          url: "/activate_2fa",
          baseURL: this.baseUrl,
          data: {
            email: localStorage.getItem("email"),
            password: localStorage.getItem("password"),
            authenticator_code: this.googleAuthenticatorCode,
          },
          withCredentials: true,
        })
          .then((res) => {
            return res;
          })
          .then((res) => {
            if (res.data.status) {
              if (res.data.status.code == 0) {
                this.user = res.data.content.user;
                localStorage.setItem("name", this.user.name);
                localStorage.setItem("surname", this.user.surName);
                if (this.rememberMe) {
                  localStorage.setItem("email", this.user.email);
                  localStorage.setItem("password", this.password);
                }
                this.setUserName();
                localStorage.roleId = this.user.userRoleId;
                localStorage.cuid = this.user._id.$oid;
                if (this.user.language) {
                  this.$ml.change(this.user.language);
                }
                this.$emit("roleId", this.user.userRoleId);
                this.getPermissionSetF(this.user.userRoleId);
                this.getCompanySettings()
                  .then((res) => {
                    return res;
                  })
                  .then((res) => {
                    localStorage.defaultCurrency =
                      this.company_settings.currency;
                  });
                if (this.user.activation) {
                  this.isPaymentModalActive = true;
                }
             
                Swal.fire({
                  title: "Doğrulama Kodunuz Aktif Edildi",
                  text: "Doğrulama kodunuz aktif edilmiştir. Anasayfaya yönlediriliyorsunuz.",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Tamam",
                  heightAuto: false,
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-primary",
                  },
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // router.push({ name: "campaignReports" });
                    console.log("sayfaya yönelndir");
                  }
                });
              }
            } else {
              console.log("istek hatalı");
            }
          });
      } else {
       
        Swal.fire({
          text: "Lütfen google authenticator kodunu giriniz",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Tamam",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
        //     Notification.open({
        //     message: 'Lütfen google authenticator kodunu giriniz',
        //     type: 'is-danger',

        // })
      }
    },

    initialize_2faF() {
      axios({
        method: "POST",
        url: "/initialize_2fa",
        baseURL: this.baseUrl,
        data: {
          email: localStorage.getItem("email"),
          password: localStorage.getItem("password"),
        },
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
            Swal.fire({
              title: "İki Adımlı Doğrulama Hakkında",
              html: "<div style='text-align: left;'>Minimumcrm hesabınızın daha güvenli olmasını sağlayacak Google 2 Adımlı Doğrulama yöntemine geçiyoruz.<br><br>Minimumcrm'de Oturum açarken parolanızın yanında mobil cihazınıza kurulan “<b>Google Authenticator</b>” uygulamasının ürettiği kodu da kullanmanız gerekecek. Böylece iki adımlı doğrulama hesabına yalnızca sizin erişebildiğinize emin olmanızı sağlayacak.<br><br>Konu ile ilgili detaylı bilgiye “<b>Yardım</b>” sayfamızdan ya da “<b>0232 483 0 444</b>” numaralı destek hattımızı arayarak ulaşabilirsiniz.</div>",

              buttonsStyling: false,
              confirmButtonText: "Tamam",
              heightAuto: false,
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            });
            this.initialize2faData.qrPdfDownloadLink =
              res.data.content.qr_pdf_download_link;
            this.initialize2faData.qrImageDownloadLink =
              res.data.content.qr_image_download_link;
            this.initialize2faData.twofaSecret = res.data.content.twofa_secret;
            this.initialize2faData.twofaqrPath = res.data.content.twofa_qr_path;
          } else {
            console.log("istek hatalı");
          }
        });
    },

    pdfDownload() {
      window.open(this.initialize2faData.qrPdfDownloadLink);
    },

    inputFocus(e) {
      var target = e.srcElement;
      var maxLength = parseInt(target.attributes["maxlength"].value, 10);
      var myLength = target.value.length;
      if (myLength >= maxLength) {
        var next = target;
        while ((next = next.nextElementSibling)) {
          if (next == null) {
            break;
          }
          if (next.tagName.toLowerCase() == "input") {
            next.focus();
            break;
          }
        }
      } else if (myLength == 0) {
        var next = target;
        while ((next = next.previousElementSibling)) {
          if (next == null) {
            break;
          }
          if (next.tagName.toLowerCase() == "input") {
            next.focus();
            break;
          }
        }
      }

      this.auth_code =
        this.input1 +
        this.input2 +
        this.input3 +
        this.input4 +
        this.input5 +
        this.input6;
      if (this.auth_code.length == 6) {
        // this.input1=""
        // this.input2=""
        // this.input3=""
        // this.input4=""
        // this.input5=""
        // this.input6=""

        var authenticator_code = {};
        var loginForm = {};
        var loginForm = this.loginForm;
        authenticator_code = this.auth_code;
        loginForm = JSON.parse(localStorage.getItem("loginData"));
        loginForm = { loginForm, authenticator_code };
       
        axios({
          method: "POST",
          url: "/authenticateUser_2fa_finalize",
          baseURL: this.baseUrl,
          data: {
            email: localStorage.getItem("email"),
            password: localStorage.getItem("password"),
            authenticator_code: authenticator_code,
          },
          withCredentials: true,
        })
          .then((res) => {
            return res;
          })
          .then((res) => {
            if (res.data.status) {
              if (res.data.status.code == 0) {
                this.user = res.data.content.user;
                localStorage.setItem("name", this.user.name);
                localStorage.setItem("surname", this.user.surName);
                if (this.rememberMe) {
                  localStorage.setItem("email", this.user.email);
                  localStorage.setItem("password", this.password);
                }
                this.setUserName();
                localStorage.roleId = this.user.userRoleId;
                localStorage.cuid = this.user._id.$oid;
                if (this.user.language) {
                  this.$ml.change(this.user.language);
                }
                this.$emit("roleId", this.user.userRoleId);
                this.getPermissionSetF(this.user.userRoleId);
                this.getCompanySettings()
                  .then((res) => {
                    return res;
                  })
                  .then((res) => {
                    localStorage.defaultCurrency =
                      this.company_settings.currency;
                  });
                if (this.user.activation) {
                  this.isPaymentModalActive = true;
                }
                // router.push({ name: "campaignReports" });
                this.input1 = "";
                this.input2 = "";
                this.input3 = "";
                this.input4 = "";
                this.input5 = "";
                this.input6 = "";
                this.auth_code = "";
              } else {
                this.input1 = "";
                this.input2 = "";
                this.input3 = "";
                this.input4 = "";
                this.input5 = "";
                this.input6 = "";
                this.auth_code = "";
                document.getElementById("input1").focus();
                Swal.fire({
                  text: res.data.status.details,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Tamam",
                  heightAuto: false,
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              }
            } else {
              console.log("istek hatalı");

              this.input1 = "";
              this.input2 = "";
              this.input3 = "";
              this.input4 = "";
              this.input5 = "";
              this.input6 = "";
              this.auth_code = "";
              document.getElementById("input1").focus();
            }
          });
      }
    },
    getPermissionSetF(userRoleId) {
      axios({
        method: "POST",
        url: "/getPermissionSet",
        data: {
          roleId: userRoleId,
        },
        baseURL: this.baseUrl,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
            localStorage.loginCookie = true;
            this.setRules();
            if (this.windowWidth < this.maxMobilSize) {
              this.$router.push("/opportunities");
            } else {
              this.$router.push("/deals");
            }
          } else if (res.data.status.code == 2054) {
            // this.$router.push('/orderPayment')
            //  this.$router.push('/settings')
            this.$router.push({
              path: "settings",
              query: { paymentStatus: "userManagement" },
            });
            //  $('#buymodal').modal('show')
            console.log("token yok ****///////////////*****");
            //  this.$refs.buymodalSelector.showBuyModal()
            //  let asd=this.$refs.buymodalSelector.data.price
            //   let dataaa=this.$refs.buymodalSelector.data
            //  console.log(dataaa);
            //  console.log("asd başlangıç");
            //   console.log(asd)
            //   console.log("asd bitiş");
            //  this.$refs.buymodalSelector.getPrice()
            //    this.$refs.buymodalSelector.getSavedCreditCards()
            //  this.buymodal=true
          }
        });
    },
    setRules() {
      try {
        axios({
          method: "GET",
          url: `/getUserPermissions`,
          baseURL: process.env.API_URL,
          withCredentials: true,
        }).then((rez) => {
          var permissions = [];
          console.log("res of get user permissions");
          console.log(rez);
          permissions = rez.data;
          localStorage.setItem("rules", JSON.stringify(permissions));
          this.$ability.update(defineAbilityFor(permissions));
        });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    },
  },
  created() {
    this.twofaActivatedControl();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-panel-header {
  border-radius: 16px 16px 0 0;
  min-height: 60px;
}
.lh13 {
  line-height: 1.3rem;
}
.numberSpan {
  background-color: rgba(11, 99, 206, 0.1);
  color: #0b63ce;
}
.numberSpann {
  background-color: rgba(11, 99, 206, 0.1);
}
.fw600 {
  font-weight: 600;
}
.btnBorder {
  border: 0;
}
.helpLink {
  color: #ffffff;
}
.pinkCol {
  background-color: rgba(225, 96, 77, 0.15);
  padding: 16px 12px 12px 16px;
}
.warningDiv {
  background-color: #da1414;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  padding-left: 16px;
}
.pinkColText {
  color: #da1414;
  font-size: 13px;
  line-height: 18px;
}
.pinkColBtn {
  background-color: rgba(0, 0, 0, 0);
  color: #09101d;
  font-weight: 600;
}
.fs13 {
  font-size: 14px;
}
.inputStyle {
  height: 40px;
  color: #da1414;
  background-color: #f6f8fb;
  border: 0;
  padding-left: 13px;
  font-size: 15px;
  padding-top: 9px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
}
.pr13 {
  padding-right: 13px;
}
.inputNumberStyle {
  width: 48px;
  height: 48px;
  background-color: #f4f6f9;
  box-sizing: border-box;
  border: 1px solid #dadee3;
  text-align: center;
  flex: none;
  order: 0;
  border-radius: 8px;
  font-size: 28px;
}
.containerDiv {
  max-width: 446px;
  height: 282px;
}
.colorGray {
  color: #858c94;
}
.card-header {
  background-color: #edf9f0;
  height: 56px;
  border-bottom: 1px solid #287d3c;
}
.contDiv {
  max-width: 450px;
  border-radius: 8px;
  box-shadow: 0px 17.5px 70px rgba(0, 0, 0, 0.12);
}
.copyIcon {
  color: #858c94;
  cursor: pointer;
}
.cursorPointer {
  cursor: pointer;
}
.is-size-4 {
  font-size: 20px;
}
@media (max-width: 576px){
  .menuMobil{
    display: flex;
    flex-wrap: nowrap;
    text-wrap: nowrap;
    overflow-x: auto;
    overflow-y: clip !important;
    width: calc(100vw - 120px) !important;
  }
}
</style>
